<div class="" style="position: relative; height: 100%">
  @if (invalidQuantity) {
    <span class="invalid-quantity">
      {{ 'globalUi.availableQuantity' | translate: { count: maxQuantity } }}
    </span>
  }

  <div class="input-number product__quantity">
    <input title="t" id="product-quantity"  class="input-number__input"   (focusout)="onUpdate(counter)" (focusin)="onUpdate(counter)" (input)="isQuantity(counter) " (input)="onUpdate(counter)"
      value="{{counter}}"  [(ngModel)]="counter"  type="number" min="1"  step="1"
      onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57">

      <div class="input-number__add">
        <button mat-icon-button (click)="increment()" >
          <img alt="" src="../../../assets/icons/increment-icon.svg">
        </button>
      </div>

      <div class="input-number__sub">
        <button mat-icon-button (click)="decrement()" >
          <img alt="" src="../../../assets/icons/close-icon.svg">
        </button>
      </div>

    </div>
  </div>



